
import { Quest, QuestCategory } from '../../../types';

export const KNOWLEDGE_SEEKER_QUESTS: Quest[] = [
  {
    id: 1800,
    category: QuestCategory.SkillBuilder,
    title: 'The Big Question',
    questlineId: 'knowledge-seeker',
    isQuestlineStart: true,
    description: 'Being a knowledge seeker starts not with answers, but with great questions. What are you curious about today?',
    details: 'Pick a topic you genuinely want to know more about (e.g., black holes, Roman soldiers, how video games are made). In your notebook, write down the topic and at least three specific questions you want to find the answers to.'
  },
  {
    id: 1801,
    category: QuestCategory.SkillBuilder,
    title: 'The Hunt for Sources',
    questlineId: 'knowledge-seeker',
    prerequisiteQuestId: 1800,
    description: 'A good researcher knows where to look for reliable information. It\'s time to find your sources.',
    details: 'With an adult\'s help, find at least two different sources to help you answer your questions. This could be a chapter in a book, a reliable website (like a museum or NASA), or an educational video.'
  },
  {
    id: 1802,
    category: QuestCategory.SkillBuilder,
    title: 'The Detective\'s Notes',
    questlineId: 'knowledge-seeker',
    prerequisiteQuestId: 1801,
    description: 'You have your sources. Now, it\'s time to extract the clues and take notes.',
    details: 'As you read or watch your sources, jot down notes in your notebook. Try to find the answers to your big questions. Don\'t copy everything, just the most important and interesting facts.'
  },
  {
    id: 1803,
    category: QuestCategory.Creator,
    title: 'The Mini-Report',
    questlineId: 'knowledge-seeker',
    prerequisiteQuestId: 1802,
    description: 'You\'ve gathered the knowledge. Now, synthesize it into your own report.',
    details: 'On a clean page in your notebook, write a short, one-page report on your topic. Use your notes to explain what you learned in your own words. You can add drawings or diagrams to make it even clearer.'
  },
  {
    id: 1804,
    category: QuestCategory.TeamUp,
    title: 'The Presentation',
    questlineId: 'knowledge-seeker',
    prerequisiteQuestId: 1803,
    description: 'The final step of research is sharing what you\'ve learned. It\'s time to teach your family.',
    details: 'Prepare a short, 2-minute presentation based on your report. Your goal is to teach your family the most interesting things you discovered. Sharing knowledge is the best way to make it stick!'
  }
];
